
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/moj-profil/zmien-zgody",
      function () {
        return require("private-next-pages/moje-konto/moj-profil/zmien-zgody.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/moj-profil/zmien-zgody"])
      });
    }
  